import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import {IconsPlugin } from 'bootstrap-vue'
Vue.use(IconsPlugin)

import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import VuePhoneNumberInput from 'vue-phone-number-input';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { VueReCaptcha } from 'vue-recaptcha-v3'
 // For more options see below
Vue.use(VueReCaptcha, { siteKey: '6LckFbEUAAAAAEC05RvzBdS3rLR9L7zn9nZooYSV' })



Vue.config.productionTip = false

new Vue({
  components: {
   
  },
  methods: {
    
  },
  // template: '<button @click="recaptcha">Execute recaptcha</button>',
  router,
  render: h => h(App)
}).$mount('#app')
